import { render, staticRenderFns } from "./CardMatrix.vue?vue&type=template&id=81a8dce2&scoped=true"
import script from "./CardMatrix.vue?vue&type=script&lang=js"
export * from "./CardMatrix.vue?vue&type=script&lang=js"
import style0 from "./CardMatrix.vue?vue&type=style&index=0&id=81a8dce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a8dce2",
  null
  
)

export default component.exports